<template>
  <div class="position-absolute" style="top: 10px; right: 10px; z-index: 10">
    <button
      class="btn rounded d-flex align-items-center justify-content-center favorite-btn"
      @click.prevent="toggleFavorite"
    >
      <i :class="favorite ? 'fas fa-star text-warning' : 'far fa-star text-white'"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: ['productId', 'isFavorite'],
  data() {
    return {
      favorite: false,
    }
  },

  mounted() {
    this.favorite = !!this.isFavorite
  },
  methods: {
    toggleFavorite() {
      axios.put(`/json/courses/${this.productId}/favorite`)
      .then(() => {
        this.favorite = !this.favorite
      })
    },
  },
}
</script>

<style scoped>
.favorite-btn {
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  transition: background 0.2s ease, transform 0.2s ease;
  --bs-btn-border-width: 0;
  --bs-btn-focus-box-shadow: none;
}

.favorite-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.favorite-btn:active {
  transform: scale(0.95);
  outline: none;
  box-shadow: none;
}
</style>
